<!-- Phase 3 create-modal template: BUI-styled form content hosted inside the
     shared Dialog.vue wrapper (see CampaignsListView.vue and
     CreateAnotherCampaignButton.vue). -->

<template>
  <div class="create-campaign-form">
    <StatusBar
      :errorMessage="errorMessage"
      :isLoading="isLoading"
      loadingMessage="Saving..."
      :isSuccess="isSuccess"
      successMessage="Saved!"
    />
    <div class="field-content">
      <!-- TODO: think about adding below-field error message & error state indication (e.g. red border) [DSP-N26CxI4P] -->
      <div class="d-flex field-row">
        <label for="ccf-name" class="basis-1/2 text-sm font-bold">Name &#9733;</label>
        <TextField id="ccf-name" data-test-id="campaign-name" v-model="values.name" class="basis-1/2" width="100%" />
      </div>
      <div class="d-flex field-row">
        <label for="ccf-start" class="basis-1/2 text-sm font-bold">Start Date</label>
        <DateField id="ccf-start" data-test-id="campaign-start" v-model="values.startDate" class="basis-1/2" width="100%" />
      </div>
      <div class="d-flex field-row">
        <label for="ccf-end" class="basis-1/2 text-sm font-bold">End Date</label>
        <DateField id="ccf-end" data-test-id="campaign-end" v-model="values.endDate" class="basis-1/2" width="100%" />
      </div>
      <div class="d-flex field-row">
        <label class="basis-1/2 text-sm font-bold">Active?</label>
        <div class="basis-1/2">
          <label class="ccf-flag">
            <input type="checkbox" v-model="values.isEnabled" id="Active" data-testid="campaign-active">
            Enabled
          </label>
        </div>
      </div>
    </div>
    <div class="form-buttons">
      <ButtonCustomized label="Cancel" data-testid="campaign-cancel" @click="onCancel" ctaSecondary />
      <ButtonCustomized label="Create" data-testid="campaign-create" cta @click="onSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import DateField from "@/components/form-fields/DateField.vue";
import TextField from "@/components/form-fields/TextField.vue";
import useCreateCampaignForm from "./CreateCampaignHelpers";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useNotifications from "@/components/Notifications/composables/notifications";
import router from '@/router';

const emit = defineEmits(['submit', 'cancel', 'success', 'fail'])

const notification = useNotifications();

const { values, submitForm, isLoading, isSuccess, errorMessage, newCampaignId } = useCreateCampaignForm();

async function onSubmit() {
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Campaign created successfully!');
    emit('success');
    router.push({name: 'campaign-editor', params: {id: newCampaignId.value}});
  } else {    // on failure
    emit('fail');
  }
}

function onCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>
.create-campaign-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: min(26rem, calc(100vw - 6rem));
  color: var(--bui-tbl-row-text, #2a2969);
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  :deep(.field label) {
    color: var(--bui-tbl-row-text, #2a2a30);
  }

  :deep(.field input[type='text']),
  :deep(.field input[type='date']) {
    color: var(--bui-ter-input-text, #1a1a1e);
    background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
    border-color: var(--bui-ter-input-border, rgba(0, 0, 0, 0.12));
    width: 100%;
  }
}

.field-row {
  align-items: center;

  label {
    color: var(--bui-tbl-row-text, #2a2a30);
  }
}

.ccf-flag {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: var(--bui-chk-checked-fill, #de3da9);
    cursor: pointer;
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
